import { ref, watch } from 'vue';
export default {
  props: {
    modelValue: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean
    },
    placeholder: {
      type: String,
      default: ''
    },
    maxlength: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    errorText: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'onBlur', 'onFocus', 'onInput'],
  setup(props, {
    emit
  }) {
    const isFocus = ref(false); // 输入框是否获取焦点
    const isHover = ref(false); // 输入框是否获取焦点
    const inputRef = ref(props.modelValue);
    watch(() => props.modelValue, () => {
      inputRef.value = props.modelValue;
    });
    const onInput = event => {
      // 向外部返回一个处理过的值
      emit('update:modelValue', event.target.value);
      emit('onInput', event.target.value);
    };
    const onFocus = () => {
      emit('onFocus', inputRef.value);
      isFocus.value = true;
    };
    const onBlur = () => {
      emit('onBlur', inputRef.value);
      isFocus.value = false;
    };
    const onHover = value => {
      isHover.value = value;
    };
    return {
      isFocus,
      isHover,
      inputRef,
      onInput,
      onHover,
      onFocus,
      onBlur
    };
  }
};